export default {
  title: "Unsubscribe",
  processing: "Processing your unsubscribe request...",
  success_title: "Unsubscribed Successfully",
  success_message: "You have been successfully unsubscribed from our mailing list.",
  error_title: "Unsubscribe Failed",
  error_message: "We were unable to process your unsubscribe request. Please try again later.",
  go_home: "Go to Home",
};
